import { message } from 'antd'
import pluralize from 'pluralize'
import { autoAdjustManyTimesheets } from '../../../HttpRequests/timesheets'
import fetch from './fetch'
import { resetSelected } from '../State/selected'
import handleException from '../../../Core/Helpers/handleException'

export default (option) => async (dispatch, getState) => {

  const { selected } = getState().modules.TimesheetsDrawer

  const data = {
    ids: selected.map(key => Number(key.split('|')[1])),
    option,
  }

  try {

    await autoAdjustManyTimesheets({ data })

    message.success(`Adjusted ${selected.length} ${pluralize('timesheet', selected.length)}`)

    dispatch(fetch())

    dispatch(resetSelected())

  } catch (error) {

    handleException(error)

  }

}
